import * as React from 'react';
import styled from 'styled-components';
import { Block, Heading, Icon, Text } from '../../../../../../../components';
import paymentImage768 from '../../../../../../../../assets/illustrations/bse-payment-768.svg';
import paymentImage640 from '../../../../../../../../assets/illustrations/bse-payment-640.svg';
import paymentActivatedImage768 from '../../../../../../../../assets/illustrations/bse-payment-activated-768.svg';
import paymentActivatedImage640 from '../../../../../../../../assets/illustrations/bse-payment-activated-640.svg';

const BlockCommon2 = styled.div`
  width: 100%;

  .container__block {
    width: 100%;
    background-color: #fff;
    padding: 24px;
    border-radius: 8px;
    margin: 16px 0px 32px 0px;
    box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
  }

  .container__block--img {
    background: url(${paymentImage640}) no-repeat center;
    border-radius: 8px;
    margin: 0px 0px 16px 0px;
    width: 100%;
    height: 88px;
    background-color: #d5e4f0;
  }

  .container__block2--img {
    background: url(${paymentActivatedImage640}) no-repeat center;
    border-radius: 8px;
    margin: 0px 0px 16px 0px;
    width: 100%;
    height: 88px;
    background-color: #d5e4f0;
  }

  .block__second {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    border-radius: 8px;
    margin: 12px auto;
    width: 100%;
    background-color: #ecf4f9;
    padding: 8px 8px 8px 16px;
  }
  .container__text h2 {
    text-align: center !important;
  }

  .container__text h2 {
    text-align: center !important;
    display: block;
  }

  .container__button {
    display: block;
  }

  @media (min-width: 640px) {
    .block__second {
      width: max-content;
    }
    .container__button {
      display: flex;
      justify-content: center;
    }
  }
  @media (min-width: 768px) {
    .block__second {
      width: 100%;
    }
    .container__block {
      display: flex;
      width: 100%;
    }
    .container__block--img {
      background: url(${paymentImage768}) no-repeat center;
      height: 196px;
      width: 220px;
    }
    .container__block2--img {
      background: url(${paymentActivatedImage768}) no-repeat center;
      height: 196px;
      width: 220px;
    }
    .container__text {
      align-items: flex-start;
      padding-left: 16px;
    }
    .btn_action_activated {
      padding-top: 0px;
    }
    .container__button {
      display: block;
      justify-content: left;
    }
    .container__text h2 {
      text-align: left !important;
    }
  }
`;

export const InteractiveButtonSecond: any = styled.button.attrs(
  (props: any) => ({
    text: props.text,
    onClick: props.onClick,
    enabled: props.enabled,
    marginTop: props.marginTop
  })
)`
  background: #5b36f2;
  padding: 10px 16px;
  border-radius: 4px;
  margin-top: 20px;
  width: 100%;
  justify-content: center;
  align-content: center;
  align-items: center;

  p {
    color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    text-align: center;
  }

  @media (min-width: 640px) {
    width: 92px;
  }
`;

const CardInProgress = ({
  activatePayment,
  paymentActivated,
  onClickActivate,
  onClickActivated,
  titleText,
  subtitleText
}: any) => {
  let title = titleText;
  let subtitle = subtitleText;
  let buttonText = '';
  if (activatePayment) {
    title = titleText || 'Genera el cargo de tu trámite activando tu pago';
    subtitle =
      subtitleText ||
      'Recuerda que una vez realizado el pago, se procederá con los demás pasos.';
    buttonText = 'Activar';
  } else if (paymentActivated) {
    title = titleText || 'El pago ha sido activado';
    subtitle =
      subtitleText ||
      'Recuerda que una vez realizado el pago, se procederá con los demás pasos.';
    buttonText = 'Ir a pagos';
  }
  return (
    <BlockCommon2>
      <div className="container__block">
        <div
          className={
            activatePayment ? 'container__block--img' : 'container__block2--img'
          }
        />
        <div className="container__text">
          <div>
            <div>
              <Heading
                text={title}
                level={2}
                color="var(--text-text02)"
                size={18}
                lineHeight={28}
                fontWeight="900"
                className=""
                align="left"
                width="100%"
              />
            </div>
          </div>
          <div className="block__second">
            <Block
              customized
              margin="5px 9px 0px 0px"
              style={{ width: 'auto' }}
            >
              <Icon name="alert-circle" size={15} />
            </Block>
            <Block style={{ width: '100%' }}>
              <Text
                color="#161D1F"
                fontSize="12px"
                lineHeight="16px"
                fontWeight="400"
                witdh="100%"
              >
                {subtitle}
              </Text>
            </Block>
          </div>
          <div className="container__button">
            {activatePayment && (
              <InteractiveButtonSecond
                data-testid="cmp-interactive-button-cardinprogress1"
                onClick={onClickActivate}
              >
                <p> {buttonText} </p>
              </InteractiveButtonSecond>
            )}
            {paymentActivated && (
              <div className="btn_action_activated">
                <InteractiveButtonSecond
                  data-testid="cmp-interactive-button-cardinprogress2"
                  onClick={onClickActivated}
                >
                  <p> {buttonText} </p>
                </InteractiveButtonSecond>
              </div>
            )}
          </div>
        </div>
      </div>
    </BlockCommon2>
  );
};

export default CardInProgress;
